'use strict';
angular.module('Uscapp').factory('creditCalcService', [function () {
    return {

        // needs to return program objects, with name and an id to use to request mappings
        getPrograms: function() {
            var courses = [
                { name: 'Diploma of Contemporary Arts', id: 1, institutionId: 3 },
                { name: 'Cert IV in somethings', id: 2, institutionId: 3 },
                { name: 'Diploma of Something Arts', id: 4, institutionId: 3 },
                { name: 'Diploma of Arts', id: 431, institutionId: 3 },
                { name: 'Diploma of Modern Arts', id: 9, institutionId: 3 }
            ];
            return courses;
        },

        // id -> id of the external program that must be in the mapping
        // should return an array of objects that describe the mapping
        getInstitutions: function() {
            var institutions = [
                { externalCode: 47, institution: 'TAFE Somewhere', externalProgramId: 1, externalProgram: 'Diploma of Contemporary Arts', internalCode: 'AR301', remainingCredits: 12, coreCredits: 1, electiveCredits: 3 },
                { externalCode: 47, institution: 'Some other institution', externalProgramId: 2, externalProgram: 'Diploma of Contemporary Arts', internalCode: 'BU301', remainingCredits: 10, coreCredits: 2, electiveCredits: 4 },
                { externalCode: 47, institution: 'A technical college', externalProgramId: 2, externalProgram: 'Diploma of Contemporary Arts', internalCode: 'BU301', remainingCredits: 10, coreCredits: 2, electiveCredits: 4 },
                { externalCode: 47, institution: 'TAFE WA', externalProgramId: 2, externalProgram: 'Diploma of Contemporary Arts', internalCode: 'BU301', remainingCredits: 10, coreCredits: 2, electiveCredits: 4 }
            ];
            return institutions;
        },

        getMappings: function() {

            //need the program name, url, discipline, external institution, credit details, external program
            var mappings = [
                {
                    externalCode: 47,
                    institution: 'TAFE WA',
                    externalProgramId: 1,
                    externalProgram: 'Diploma of Contemporary Arts',
                    internalName: 'Bachelor of Arts',
                    internalUrl: '/learn/courses-and-programs/bachelor-degrees-undergraduate-programs/bachelor-of-arts',
                    programCode: 'AR301',
                    discipline: 'humanities',
                    remainingCourses: 18,
                    coreCredits: [
                        {
                            courseName: 'Communication and thought',
                            courseCode: 'COR109'
                        }
                    ],
                    electiveCredits: [
                        {
                            courseName: 'Management and Organisational Behaviour',
                            courseCode: 'BUS104',
                        },
                        {
                            courseName: 'Accounting for Business',
                            courseCode: 'BUS106'
                        },
                        {
                            courseName: '100-level business elective',
                            count: 3
                        }
                    ]
                },
                { externalCode: 47, institution: 'TAFE WA', externalProgramId: 2, externalProgram: 'Diploma of Contemporary Arts', internalName: 'Bachelor of Business', discipline: 'business', remainingCredits: 10, coreCredits: 2, electiveCredits: 4 },
                { externalCode: 47, institution: 'TAFE WA', externalProgramId: 2, externalProgram: 'Diploma of Contemporary Arts', internalName: 'Bachelor of Business (Marketing)', discipline: 'business', remainingCredits: 10, coreCredits: 2, electiveCredits: 4 },
                { externalCode: 47, institution: 'TAFE WA', externalProgramId: 2, externalProgram: 'Diploma of Contemporary Arts', internalName: 'Bachelor of Health', discipline: 'health', remainingCredits: 10, coreCredits: 2, electiveCredits: 4 }
            ];

            return mappings;
        }


    };
}]);